import React from 'react'

const Header = () => {
  return (
    <div className="header">
      <h2 dir="rtl">Globe Soccer Awards</h2>

      <p dir="rtl" className="meta">
        <span>المكان: فندق Atlantis The Royal – دبي</span>
        <br />
        <span>التاريخ: 28 ديسمبر 2025</span>
      </p>
    </div>
  )
}

export default Header